import React from 'react';
import EffectRedirect from '../../components/EffectRedirect';
import searchFilter from '../../searchFilter';
import {useParams} from 'react-router-dom';
import {CHECKOUT_VERTICAL_PATHS} from '../../constants';

const IMPULSES_QUERY_PARAMS = 'impulsesQueryParams__0';

export const saveImpulseQueryParams = ({impulseId, search}) => {
    if (search && impulseId) {
        const queryParams = JSON.parse(localStorage.getItem(IMPULSES_QUERY_PARAMS)) || [];
        queryParams.push({impulseId, search});
        if (queryParams.length > 3) {
            queryParams.splice(3, queryParams.length - 3);
        }
        localStorage.setItem(IMPULSES_QUERY_PARAMS, JSON.stringify(queryParams));
    }
};

const CheckoutPaymentCallback = () => {
    const {impulseId, vertical} = useParams();
    const queryParams = JSON.parse(localStorage.getItem(IMPULSES_QUERY_PARAMS)) || [];
    const foundParamsObject = queryParams.find((e) => e.impulseId === impulseId);
    const foundParams = foundParamsObject ? foundParamsObject.search : '';
    const currentVertical = CHECKOUT_VERTICAL_PATHS[vertical] || vertical;
    return (
        <EffectRedirect to={`/checkout/${currentVertical}/success${searchFilter(foundParams, {impulseId})}`} replace/>
    )
}

export default React.memo(CheckoutPaymentCallback);